import axiosClient from "../../../../axiosClient"

export default async (data) => {
    const result = await axiosClient.post("/override-background-check-client-data", data)

    return result.data
}
